import Vue from 'vue';
import App from './App';
import { router } from './router';
import AMap from 'vue-amap';


import { Lazyload, Toast, Dialog } from 'vant';
import NoSleep from "nosleep.js/dist/NoSleep.min.js";

Vue.prototype.$NoSleep = NoSleep;
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Lazyload);
Vue.use(AMap);

Vue.prototype.$timer = [];

Vue.prototype.updateDriverPosition = function (tripId){
  App.methods.updateDriverPosition(tripId);
};

Toast.setDefaultOptions({ duration: 3000 ,className:'my-toast'});
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德的key
  key: 'b1e7e3dee4bdde934c8fc66bd6c5c5b5',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.PolyEditor','AMap.Geolocation']
});

new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
